export default __webpack_public_path__ + "static/media/geoloc1.c429d642.png";